import { Component } from '@angular/core';

@Component({
  selector: 'rental-not-page-found',
  templateUrl: './not-page-found.component.html',
  styleUrls: ['./not-page-found.component.scss']
})
export class NotPageFoundComponent {

}
